import React, { useState, useEffect } from "react";
import {
  Paper,
  withStyles,
  Stepper,
  StepLabel,
  Step,
  Dialog,
  CircularProgress,
  Typography
} from "@material-ui/core";
import * as actions from "./store/customerActions";
import { connect } from "react-redux";
import { snackActions } from '../../sc-utilities/SnackBar';
import History from "../../../History";
import UserForm from "./UserForm";
import * as Yup from "yup";
import CustomerForm from "./CustomerForm";
import AccountForm from "./AccountForm";
import * as userActions from "../../sc-users/User/store/userActions"
import moment from 'moment';
import * as action from "../../sc-billing/BillingAccount/store/billingAccountActions";
import { CancelToken } from 'axios';
import config from '../../../config/config';
import AppLogoLoading from '../../sc-logo';
import countries from 'i18n-iso-countries';
import { states, getStatesList, getCountryList } from '../../sc-utilities/CountriesAndUSstatesList';
import { allowedLicensingValues } from "./Details/CustomerEdit";

const styles = theme => ({
  root: {
    width: `98.9%`,
    height: "auto",
    paddingTop: theme.spacing(),
    paddingLeft: theme.spacing(),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      margin: 0,
      width: "100%",
    }
  },
  paper: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden",
    alignItems: "center",
    bottom: '15rem'
  },
  progress: {
    width: `398px`,
    height: "400px"
  },
  typographyTo: {
    marginTop: "5px",
    color: theme.palette.buttonText.default
  },
  typography: {
    marginTop: "5px",
    color: theme.palette.buttonText.default,
    position: "absolute",
    top: "40%",
    right: "0",
    textAlign: "center",
    left: "0"
  },
  logo: {
    width: "250px",
    margin: "10px"
  }
});

const CustomerCreate = props => {
  const {
    classes,
    activeCustomer,
    customer,
    translations,
    onListUsers,
    onCheckFormParams,
    onCreateCustomer,
    currentUserID,
    userLanguage,
    onCheckUserParams,
    permissions
  } = props;

  try {
    let lang = userLanguage;
    if (userLanguage.includes("zh-")) {
        lang = "zh";
    }
    countries.registerLocale(require(`i18n-iso-countries/langs/${lang}.json`));
} catch (error) {
    console.log(error)
}

  const language = userLanguage || 'en';

  const steps = [
    translations["create_customer"] || "Create customer",
    translations["create_account"] || "Create account",
    // translations["create_user"] || "Create user",
  ];

  const [data, setData] = useState({
    customer: {},
    file: {},
    account: {},
    user: {},
    preset: {},
    type: null,
    data: null,
    value: "",
    everythingDisabled: false,
    buttonEnabledDisabled: "Disable presets"
  });
  const [state, setState] = useState({
    users: [],
    orders: [],
    grades: [],
    printers: [],
    operatingSystems: [],
    Collies: [],
    loadingData: true
  });

  const [activeStep, setActiveStep] = useState({ step: 0, backValid: {} });
  const [skipped, setSkipped] = useState(new Set());
  const [backendError, setBackendError] = useState(null);

  const userCancel = CancelToken?.source();

  const fetchData = async () => {
    let userData = await onListUsers({ ActiveCustomerID: activeCustomer }, { cancelToken: userCancel });
    setState({
      users: userData,
      loadingData: false
    });
  };

  useEffect(() => {
    fetchData();
    return () => {
      userCancel.cancel('Operation canceled by user');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpload = event => {
    let file = event[0];
    if (!file) {
      setData({ ...data, fileToSend: {}, fileName: '' });
      return
    }
    setData({
      ...data,
      file: file,
      fileName: file.name,
      value: URL.createObjectURL(file)
    });
  };

  const handleSubmitCustomer = async (formData) => {
    const Address = {
      AddressLine1: formData.AddressLine1,
      AddressLine2: formData.AddressLine2,
      City: formData.City,
      State: formData?.State?.key || null,
      Country: formData?.Country?.key || null
    };
    const formSent = new FormData();
    formSent.append("File", data.file);
    formSent.append("FileName", data.fileName);
    formSent.append("Name", formData.Name);
    formSent.append("Namespace", formData.Namespace);
    formSent.append("Status", formData.Status);
    formSent.append("PasswordComplexity", formData.PasswordComplexity);
    formSent.append("Address", JSON.stringify(Address));
    formSent.append("AutoLogout", formData.AutoLogout || 0);
    formSent.append("Status", formData.Status === "active" ? 1 : 0);
    formSent.append("CreateDefaultData", formData.CreateDefaultData === "yes" ? true : false);
    formSent.append("ActiveCustomerID", activeCustomer);
    formSent.append("CreateUser", false);
    formSent.append("Timezone", formData?.Timezone);
    formSent.append("IndividualLicensingSetting", formData?.IndividualLicensingSetting);
    formSent.append("GroupLicensingSetting", formData?.GroupLicensingSetting);
    formSent.append("UniqueInventoryNumberEnabled", formData?.UniqueInventoryNumberEnabled);

    let token = localStorage.getItem("SESSION");

    formSent.append("Token", token);

    let createResult = await onCreateCustomer(formSent);
    if (createResult.data && createResult.data.status !== 200) {
      if (createResult.data.errorKey) {
        setBackendError(createResult.data.errorKey);
      }
      setActiveStep({ ...activeStep, step: 0 });
      return;
    }
    History.goBack();
    return;
  }

  const handleSubmitAccount = async (formData) => {
    const Address = {
      AddressLine1: data?.customer.AddressLine1,
      AddressLine2: data?.customer.AddressLine2,
      City: data?.customer.City,
      State: data?.customer.State?.key,
      Country: data?.customer.Country?.key
    };

    const Communication = {
      Language: formData.Language,
      PhoneNumber: formData.PhoneNumber,
      Email: formData.Email
    };

    formData["Communication"] = JSON.stringify(Communication);
    formData["Accountant"] = formData["Accountant"].value;

    const AddressAccount = {
      AddressLine1: formData?.AddressLine1,
      AddressLine2: formData?.AddressLine2,
      City: formData?.City,
      Country: formData?.Country?.key ? formData?.Country?.key : formData?.Country || '',
      State: formData?.State?.key ? formData?.State?.key : formData?.State || ''
    };
    formData["Address"] = AddressAccount;

    const formSent = new FormData();
    formSent.append("File", data.file);
    formSent.append("FileName", data.fileName);
    formSent.append("Name", data.customer.Name);
    formSent.append("Namespace", data.customer.Namespace);
    formSent.append("PasswordComplexity", data.customer.PasswordComplexity);
    formSent.append("CreateDefaultData", data?.customer?.CreateDefaultData === "yes" ? true : false);
    formSent.append("Timezone", data?.customer?.Timezone);

    formSent.append("Address", JSON.stringify(Address));
    formSent.append("AddressAccount", JSON.stringify(AddressAccount));
    formSent.append("Status", data.customer.Status === "active" ? 1 : 0);
    formSent.append("AutoLogout", formData.AutoLogout || 0);
    formSent.append("ActiveCustomerID", activeCustomer);
    formSent.append("Preset", "");

    let token = localStorage.getItem("SESSION");

    formSent.append("Token", token);
    formSent.append("CreateUser", false);
    formSent.append("Account", JSON.stringify(formData));

    let createResult = await onCreateCustomer(formSent);
    if (createResult.data && createResult.data.status !== 200) {
      if (createResult.data.errorKey) {
        setBackendError(createResult.data.errorKey)
        if (createResult.data.errorKey === "Namespace") setActiveStep({ ...activeStep, step: 0 });
        return;
      }
      return
    }

    History.goBack();
    return;
  }

  const handleSubmitUser = async (formData) => {

    const Address = {
      AddressLine1: data?.customer.AddressLine1,
      AddressLine2: data?.customer.AddressLine2,
      City: data?.customer.City,
      State: data?.customer.State?.key,
      Country: data?.customer.Country?.key
    };

    if (Object.keys(data.account).length !== 0) {
      const Communication = {
        Language: data.account.Language,
        PhoneNumber: data.account.PhoneNumber,
        Email: data.account.Email
      };

      const AddressAccount = {
        City: data.account.City,
        Country: data.account.Country?.key,
        State: data.account.State?.key,
        AddressLine1: data.account.AddressLine1,
        AddressLine2: data.account.AddressLine2,
      };
      data.account["Address"] = AddressAccount;

      data.account["Communication"] = JSON.stringify(Communication);
      data.account["Accountant"] = data?.account["Accountant"].value;
      const formSent = new FormData();
      formSent.append("File", data.file);
      formSent.append("FileName", data.fileName);
      formSent.append("Name", data.customer.Name);
      formSent.append("Namespace", data.customer.Namespace);
      formSent.append("CreateDefaultData", data?.customer?.CreateDefaultData === "yes" ? true : false);
      formSent.append("Timezone", data?.customer?.Timezone);

      formSent.append("PasswordComplexity", data.customer.PasswordComplexity);
      formSent.append("Address", JSON.stringify(Address));
      formSent.append("Status", data.customer.Status === "active" ? 1 : 0);
      formSent.append("AutoLogout", formData.AutoLogout || 0);
      formSent.append("ActiveCustomerID", activeCustomer);
      formSent.append("Account", JSON.stringify(data.account));
      formSent.append("Preset", "");
      formSent.append("FirstName", formData.FirstName);
      formSent.append("LastName", formData.LastName);
      formSent.append("Username", formData.Username);
      formSent.append("Email", formData.Email);
      formSent.append("PhoneNumber", formData.PhoneNumber);
      formSent.append("Position", formData.Position);
      formSent.append("Password", formData.Password);
      formSent.append("UserStatus", formData.UserStatus === "active" ? 1 : 0);
      formSent.append("CreateUser", true);

      let token = localStorage.getItem("SESSION");

      formSent.append("Token", token);
      if (formSent['Status'] === 'active') {
        formSent['Status'] = 1
      }

      let createResult = await onCreateCustomer(formSent);
      if (createResult.data && createResult.data.status !== 200) {
        if (createResult.data.errorKey) {
          setBackendError(createResult.data.errorKey);

          if (createResult.data.errorKey === "Namespace") {
            setActiveStep({ ...activeStep, step: 0 });
            return
          }
          return
        }
      }
      History.goBack();
      return;
    }
    const formSent = new FormData();
    formSent.append("File", data.file);
    formSent.append("FileName", data.fileName);
    formSent.append("Name", data.customer.Name);
    formSent.append("Namespace", data.customer.Namespace);
    formSent.append("CreateDefaultData", data?.customer?.CreateDefaultData === "yes" ? true : false);
    formSent.append("Timezone", data?.customer?.Timezone);

    formSent.append("PasswordComplexity", data.customer.PasswordComplexity);
    formSent.append("Address", JSON.stringify(Address));
    formSent.append("Status", data.customer.Status === "active" ? 1 : 0);
    formSent.append("AutoLogout", formData.AutoLogout || 0);
    formSent.append("ActiveCustomerID", activeCustomer);
    formSent.append("Account", "");
    formSent.append("Preset", "");
    formSent.append("FirstName", formData.FirstName);
    formSent.append("LastName", formData.LastName);
    formSent.append("Username", formData.Username);
    formSent.append("Email", formData.Email);
    formSent.append("PhoneNumber", formData.PhoneNumber);
    formSent.append("Position", formData.Position);
    formSent.append("Password", formData.Password);
    formSent.append("UserStatus", formData.UserStatus === "active" ? 1 : 0);
    formSent.append("CreateUser", true);

    let token = localStorage.getItem("SESSION");

    formSent.append("Token", token);
    let createResult = await onCreateCustomer(formSent);
    if (createResult.data && createResult.data.status !== 200) {
      if (createResult.data.errorKey) {
        setBackendError(createResult.data.errorKey);
        if (createResult.data.errorKey === "Namespace") {
          setActiveStep({ ...activeStep, step: 0 });
          return
        }
      }
      return
    }

    History.goBack();
    return;
  };

  const isStepSkipped = step => {
    return skipped.has(step);
  };

  const isStepOptional = step => {
    return step === 1 || step === 2;
  };

  const handleSkip = key => {
    if (!isStepOptional(activeStep.step)) {
      throw new Error("");
    }
    setActiveStep({
      step: activeStep.step + 1,
      backValid: { ...activeStep.backValid, [key]: false }
    });
    setSkipped(prevSkipped => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep.step);
      return newSkipped;
    });
  };

  const handleBack = (form, key) => {
    setData({ ...data, [`${key}`]: form });
    setActiveStep({ ...activeStep, step: activeStep.step - 1 });
  };

  let sendMessageOnNext = null

  const handleNext = async (form, key) => {

    let checkResponse = await onCheckFormParams({
      ActiveCustomerID: activeCustomer,
      Namespace: form.Namespace
    })

    if (checkResponse?.status !== 200) {
      snackActions.snackBarComponent(checkResponse.message, "warning")
      sendMessageOnNext = true
      return
    }

    if (key === "user") {
      let userCheckResponse = await onCheckUserParams({
        ActiveCustomerID: activeCustomer,
        Email: form.Email
      })

      if (userCheckResponse && userCheckResponse.status !== 200) {
        if (userCheckResponse.error && userCheckResponse.error && userCheckResponse.error.errorKey) {
          setBackendError(userCheckResponse.error.errorKey);
          if (sendMessageOnNext) snackActions.snackBarComponent(userCheckResponse.message, "warning")
          sendMessageOnNext = true
          return
        }
      }
    }
    sendMessageOnNext = null
    setData({ ...data, [`${key}`]: form });
    setActiveStep({
      step: activeStep.step + 1,
      backValid: { ...activeStep.backValid, [key]: true }
    });

  };

  const cancelHandler = () => {
    History.goBack();
  };

  let initialValuesCustomer = {
    Name: data?.customer?.Name || "",
    Namespace: data?.customer?.Namespace || "",
    AddressLine1: data?.customer?.AddressLine1 || "",
    AddressLine2: data?.customer?.AddressLine2 || "",
    State: data?.customer?.State || null,
    City: data?.customer?.City || "",
    Country: data?.customer?.Country || "",
    Status: data?.customer?.Status ? data.customer.Status : 'active',
    CreateDefaultData: data?.customer?.CreateDefaultData || "yes",
    AutoLogout: data?.customer?.AutoLogout || 0,
    PasswordComplexity: data?.customer?.PasswordComplexity || "securaze_basic",
    Timezone: data?.customer?.Timezone && data?.customer?.Timezone !== '' ? data?.customer?.Timezone : config?.timezone,
    IndividualLicensingSetting: customer?.IndividualLicensingSetting || "default_off",
    GroupLicensingSetting: customer?.GroupLicensingSetting || "default_off",
    UniqueInventoryNumberEnabled: customer?.UniqueInventoryNumberEnabled || false,
  };

  let formSettingsCustomer = {
    Validation: {
      Name: Yup.string().required("Required"),
      Namespace: Yup.string()
        .trim()
        .matches(/^[a-z0-9_-]+$/, "Is not in correct format")
        .required(),
      AddressLine1: Yup.string().required("Required"),
      AddressLine2: Yup.string().notRequired(),
      City: Yup.string().required("Required"),
      State: Yup.string().when("Country", {
        is: "United States of America",
        then: Yup.string().required()
      }),
      Country: Yup.string().required("Required"),
      Status: Yup.string().required("Required"),
      AutoLogout: Yup.number().required("Required"),
      PasswordComplexity: Yup.string().required("Required"),
      IndividualLicensingSetting: Yup.string().oneOf(allowedLicensingValues).required("Required"),
      GroupLicensingSetting: Yup.string().oneOf(allowedLicensingValues).required("Required"),
      UniqueInventoryNumberEnabled: Yup.boolean().notRequired(),
    },
    ButtonSubmit: {
      Title: translations["save"] || "SAVE",
      Color: "primary"
    },
    ButtonNext: {
      Title: translations["next"] || "Next",
      Color: "primary"
    },
    ButtonCancel: {
      Title: translations["cancel"] || "CANCEL",
      handleCancel: cancelHandler
    }
  };

  let initialValuesAccount = {
    BillingMode: data.account.BillingMode || "prepaid",
    Status: data?.account?.Status || 'prepared',
    ActivationDate: data.account.ActivationDate || moment(),
    ExpiresAt: moment().add(1, "years"),
    BillingDay: data.account.BillingDay || 1,
    CustomerOrder: data?.account?.CustomerOrder || "",
    VAT: data.account.VAT || "",
    TaxClassification: data.account.TaxClassification || "",
    TermsOfPayment: data.account.TermsOfPayment || "dor",
    Accountant: data?.account?.Accountant || "",
    Language: data.account.Language || "en",
    PhoneNumber: data.account.PhoneNumber || "",
    Email: data.account.Email || "",
    CustomerAddress: false,
    AddressLine1: "",
    AddressLine2: "",
    City: "",
    Country: "",
    State: null
  };

  let formSettingsAccount = {
    Validation: {
      BillingMode: Yup.string().required('Required'),
      Status: Yup.string().required('Required'),
      ActivationDate: Yup.date()
        .required(),
      ExpiresAt: Yup.date()
        .required(),
      BillingDay: Yup.number().required('Required').min(1).max(28),
      CustomerOrder: Yup.string().notRequired('Required'),
      VAT: Yup.string().notRequired('Required'),
      TaxClassification: Yup.string().notRequired('Required'),
      TermsOfPayment: Yup.string().notRequired('Required'),
      CustomerID: Yup.string().notRequired('Required'),
      Accountant: Yup.string().notRequired('Required'),
      Language: Yup.string().required('Required'),
      PhoneNumber: Yup.string().notRequired('Required'),
      Email: Yup.string().email().notRequired('Required'),
      CustomerAddress: Yup.boolean().notRequired(),
      AddressLine1: Yup.string().required('Required'),
      AddressLine2: Yup.string().notRequired(),
      City: Yup.string().required('Required'),
      State: Yup.string().when("Country", {
        is: "United States of America",
        then: Yup.string().required()
      }),
      Country: Yup.string().required('Required')
    },
    ButtonSubmit: {
      Title: translations["finish"] || "Finish",
      Color: "primary"
    },
    ButtonBack: {
      Title: translations["back"] || "Back",
      handleBack: handleBack
    },
    ButtonSkip: {
      Title: translations["skip"] || "Skip",
      Color: "primary",
      handleSkip: handleSkip
    },
    ButtonNext: {
      Title: translations["next"] || "Next",
      Color: "primary",
    },
    ButtonCancel: {
      Title: translations["cancel"] || "CANCEL",
      handleCancel: cancelHandler
    }
  };

  let initialValuesUser = {
    FirstName: data.user.FirstName || "",
    LastName: data.user.LastName || "",
    Username: data.user.Username || "",
    Email: data.user.Email || "",
    PhoneNumber: data.user.PhoneNumber || "",
    Position: data.user.Position || "",
    Password: "",
    RepeatPassword: "",
    UserStatus: data.user.UserStatus || "active"
  };
  let formSettingsUser = {
    Validation: {
      FirstName: Yup.string().required("Required"),
      LastName: Yup.string().required("Required"),
      Username: Yup.string()
        .trim()
        .matches(/^[a-zA-Z0-9]+$/, "Is not in correct format")
        .test("len", "Must be different of ", val => val !== "root")
        .required("Required"),
      Email: Yup.string()
        .email("Invalid email")
        .required("Required"),
      PhoneNumber: Yup.string().required("Required"),
      Position: Yup.string().notRequired(),
      Password: Yup.string().min(3, "Password should have at least 3 characters").required("Required"),
      RepeatPassword: Yup.string().min(3)
        .oneOf([Yup.ref("Password"), null], "Passwords must match")
        .required("Required"),
      UserStatus: Yup.string().required("Required")
    },
    ButtonSubmit: {
      Title: translations["finish"] || "Finish",
      Color: "primary"
    },
    ButtonBack: {
      Title: translations["back"] || "Back",
      handleBack: handleBack
    },
    ButtonCancel: {
      Title: translations["cancel"] || "CANCEL",
      handleCancel: cancelHandler
    }
  };

  const getStepContent = stepIndex => {
    if (state.users) {
      switch (stepIndex) {
        case 0:
          return (
            <CustomerForm
              data={data}
              countryList={getCountryList(countries, userLanguage)}
              usStatesList={getStatesList(states)}
              activeCustomer={activeCustomer}
              onCreateCustomer={onCreateCustomer}
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              handleSubmit={handleSubmitCustomer}
              formSettings={formSettingsCustomer}
              initialValues={initialValuesCustomer}
              translations={translations}
              permissions={permissions}
              handleNext={handleNext}
              backValid={activeStep.backValid}
              handleUpload={handleUpload}
              imageValue={data.value}
              backendError={backendError}
              setBackendError={() => setBackendError(null)}
            />
          );
        case 1:
          return (
            <AccountForm
              data={data}
              state={state}
              handleSkip={handleSkip}
              customer={customer}
              cancelHandler={cancelHandler}
              activeCustomer={activeCustomer}
              onCreateCustomer={onCreateCustomer}
              initialValues={initialValuesAccount}
              formSettings={formSettingsAccount}
              countryList={getCountryList(countries, language)}
              usStatesList={getStatesList(states)}
              handleSubmit={handleSubmitAccount}
              currentUserID={currentUserID}
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              users={state.users}
              handleBack={handleBack}
              backValid={activeStep.backValid}
              translations={translations}
              handleNext={handleNext}
              setBackendError={() => setBackendError(null)}
            />
          );
        case 2:
          return (
            <UserForm
              data={data}
              state={state}
              handleSkip={handleSkip}
              customer={customer}
              cancelHandler={cancelHandler}
              activeCustomer={activeCustomer}
              onCreateCustomer={onCreateCustomer}
              currentUserID={currentUserID}
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              formSettings={formSettingsUser}
              initialValues={initialValuesUser}
              backValid={activeStep.backValid}
              handleSubmit={handleSubmitUser}
              translations={translations}
              handleNext={handleNext}
              handleBack={handleBack}
              backendError={backendError}
              setBackendError={() => setBackendError(null)} />
          );
        default:
          return "Unknown stepIndex";
      }
    }
  };

  return (
    <div className={classes.root}>
      <Dialog
        disableBackdropClick={true}
        disableEscapeKeyDown={false}
        open={state.loadingData}
        PaperProps={{
          classes: {
            root: classes.paper
          }
        }}
      >
        <AppLogoLoading />
      </Dialog>
      <Paper style={{ display: "flow-root" }}>
        <Stepper activeStep={activeStep.step} alternativeLabel>
          {steps.map((label, index) => {
            const stepProps = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {!state.loadingData ? getStepContent(activeStep.step) : null}
      </Paper>
      <Dialog
        disableBackdropClick={true}
        disableEscapeKeyDown={false}
        open={customer.snackStart}
        PaperProps={{
          classes: {
            root: classes.paper
          }
        }}
      >
        <div style={{ marginBottom: "1px", position: "relative" }}>
          <CircularProgress
            variant="static"
            color="primary"
            style={{ marginBottom: "10px" }}
            size={300}
            value={customer && customer.progress ? Number(customer.progress) : 0}
          />
          <Typography className={classes.typography} variant="h4">
            {" "}
            {customer.progress ? customer.progress : 0}%{" "}
          </Typography>
          <br />
        </div>
        <Typography variant="h5" className={classes.typographyTo}>
          Please do not refresh this page. Uploading{" "}
          {customer.loadSize ? customer.loadSize : 0} /{" "}
          {customer.maxSize ? customer.maxSize : 0}MB
        </Typography>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    activeCustomer: state?.core?.login?.activeCustomer?.CustomerID,
    translations: state?.translate?.translations?.activeTranslations || {},
    currentUserID: state?.core?.login?.user?.UserID || "",
    customer: state?.customer?.customers,
    userLanguage: state?.core?.login?.userSettings?.DefaultLanguage,
    permissions: state?.core?.login?.permissions ?? []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchOrders: (id, options) => dispatch(actions.fetchOrders(id, options)),
    fetchCollies: (id, options) => dispatch(actions.fetchCollies(id, options)),
    fetchPrinters: (id, options) => dispatch(actions.fetchPrinters(id, options)),
    onFetchLogos: (id) => dispatch(actions.fetchLogos(id)),
    fetchGrades: (id, options) => dispatch(actions.fetchGrades(id, options)),
    updateCustomerStore: params => dispatch(actions.updateCustomerStore(params)),
    fetchOperatingSystems: (params, options) => dispatch(actions.fetchOperatingSystems(params, options)),
    onCreateCustomer: data => dispatch(actions.createCustomer(data)),
    onListPlans: data => dispatch(actions.loadPlans(data)),
    onListUsers: (id, options) => dispatch(action.listUsers(id, options)),
    updatePresets: params => dispatch(actions.updatePresets(params)),
    onCheckFormParams: data => dispatch(actions.checkFormParams(data)),
    onCheckUserParams: data => dispatch(userActions.checkFormParams(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CustomerCreate));